"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Setoid_1 = require("fp-ts/lib/Setoid");
var isEqual = require("date-fns/is_equal");
var function_1 = require("fp-ts/lib/function");
var SetoidUtils;
(function (SetoidUtils) {
    SetoidUtils.setoidStrict = {
        equals: Setoid_1.strictEqual,
    };
    /**
     * @deprecated use fp-ts
     */
    SetoidUtils.setoidDate = {
        equals: function (a, b) { return isEqual(a, b); },
    };
    SetoidUtils.contramap = function (f, fa) {
        return {
            equals: function_1.on(fa.equals)(f),
        };
    };
})(SetoidUtils = exports.SetoidUtils || (exports.SetoidUtils = {}));
